import { updateObjectValue } from './utils'
import { execAction } from './actionlist/action';
import clonedeep from "lodash.clonedeep"
import { debugEnv } from '../..';
import isEqual from 'react-fast-compare';
//import isEqual from "react-fast-compare"

export const reducer = (state, action) => {
	//let newstate = { ...state } //clonedeep(state);
	let newstate = clonedeep(state);
	//console.log('dispatch', action, state)

	switch (action.type) {
		case "set-meta": //espera: {payload}
			newstate.meta = action.payload;
			newstate.meta.location.current = state.meta?.location.current

			// console.log("newstate", 'meta', newstate.meta.location, newstate);
			return newstate;
		case "set-data": //espera: {path, payload}
			updateObjectValue(newstate, action.path, action.payload, action.override || action.overwrite, action.autocreate)

			if (isEqual(state, newstate)) return state;

			return newstate;
		case "activate-form": //espera: {name, data?}
			if (!(newstate.forms instanceof Array)) newstate.forms = []
			newstate.forms.push({ name: action.name, data: JSON.parse(JSON.stringify(action.data || {})), reset: true, entity: action.entity })
			return newstate;
		case "show-module": //espera: {name, show}

			if (!(newstate.hidden instanceof Array)) newstate.hidden = []
			//console.log(action.show ? "showing" : "hidding", action.name, "from hidding: ", newstate.hidden);

			if (action.show) newstate.hidden = newstate.hidden.filter(board => (action.name instanceof Array ? !action.name.includes(board) : board !== action.name))
			else if (action.name instanceof Array) newstate.hidden.push(...(action.name))
			else newstate.hidden.push(action.name)

			return newstate;
		case "close-form": //espera: {index}
			if (!(newstate.forms instanceof Array)) newstate.forms = []

			if (isNaN(action.index)) newstate.forms = []
			else newstate.forms[action.index] = null

			if (!newstate.forms.filter(item => !!item).length) newstate.forms = []

			return newstate;
		case 'set-common':
			newstate.common = action.payload
			return newstate;
		default: throw Error("unknown action type:", action.type)
	}
}


export const observerReducer = (state, action) => {
	let buf;
	//console.log("observer", action);

	switch (action.type) {
		case "attach":
			if (!(buf = state[action.class || "timer"])) {
				state[action.class || "timer"] = buf = {}
			}

			if (buf[action.label]) {
				buf[action.label](); //dettaching
			}

			buf[action.label] = action.dettach;
			break;
		case "dettach":
			if (!(buf = state[action.class || "timer"])) {
				state[action.class || "timer"] = buf = {}
			}

			if (buf[action.label]) {
				buf[action.label](); //dettaching
			}

			delete buf[action.label];

			break;
		case "dettach-all":
			Object.entries(state).forEach(([k, val]) => {
				Object.entries(val).forEach(([k, dettach]) => {
					if (dettach) dettach();
				})
			})

			state = {};

			break;
		default: throw Error("unknown action type:", action.type, "for observerReducer")
	}
	return state;
}

export const actionReducer = (_state, action) => {
	const state = clonedeep(_state);
	const thread = action.thread || 'main';

	state[thread] = threadActionReducer(state[thread] || [], action)

	if (debugEnv)
		window.appActionObject = state;

	return state;
}

const threadActionReducer = (state, action) => {
	switch (action.type) {
		case "add":
			return [...state, action.actions]
		case "remove":
			if (state.length) {
				const curr = state.shift();
				if (curr?.tasks?.length) {
					return [{ ...curr, tasks: curr.tasks.slice(1) }, ...state]
				} else return state
			}
			else {
				console.error("Can't remove not running tasks.", action);
				return state;
			}
		case "abort":
			if (state.length) {
				const curr = state.shift();
				if (curr?.tasks?.length) {
					return [{ ...curr, tasks: [curr.tasks[0]] }, ...state]
				} else {
					console.error("Can't abort ended tasks.", action);
					return state
				}
			}
			else {
				console.error("Can't abort not running tasks.", action);
				return state;
			}
		case "add-tasks":
			if (state.length) {
				const curr = state.shift();
				if (curr?.tasks) {
					const newtasks = curr.tasks;
					newtasks.splice(1, 0, ...action.tasks)
					return [{ ...curr, tasks: newtasks }, ...state];
				} else return state
			}
			else {
				console.error("Can't add tasks while not processing.", action);
				return state;
			}
		default:
			console.error("Wrong call on action dispatch.", action);
			return;
	}
}

export const actionProcessor = ({ currentAction, thread, anyProcessing, processing, action, actionDispatch, setProcessing, dispatch, data, currentMeta, currentScope }) => async () => {
	if (currentAction && !processing) {
		const { tasks, processingFlagPath, data: localData, ...props } = currentAction;
		const task = tasks && tasks[0]

		if (task) {
			let taskName, extraData = {}, actionProps;

			//console.log("preparing task", task, thread);

			if (typeof task === "string") taskName = task; //simple named task
			else if (task instanceof Array) [taskName, extraData] = task; //task with extra data
			else ({ extraData, name: taskName, ...actionProps } = task); //routine inline task

			//if (actionProps && (!actionProps.type || actionProps.type === "global")) actionProps = undefined;
			if (!actionProps?.type || actionProps.type === "global") {
				if (taskName) {
					const actionExtendedList = [...action, { name: "refreshed", type: "refreshed" }, { name: "refresh", type: "refresh" }, { name: "close", type: "close" }]
					const taskDefinition = actionExtendedList.find(({ name }) => name === taskName)

					actionProps = { ...actionProps, ...taskDefinition }
				}
			}

			if (!actionProps?.type || actionProps.type === "global") {
				console.warn(`Action ${taskName || "unnamed"} not found.`);
				actionDispatch({ type: "remove", thread });
			} else {
				setProcessing(true, thread);

				const donefn = () => {
					if (processingFlagPath) dispatch({ type: "set-data", path: processingFlagPath, payload: tasks.length - 1, autocreate: false })

					actionDispatch({ type: "remove", thread });
					setProcessing(false, thread);
				}

				const execParams = {
					action: actionProps,
					...props,
					data: { ...localData, ...extraData, ...(data[`_local_${thread || 'main'}`] || data._local || {}) },
					dispatch: dispatch,
					outerData: data,
					meta: currentMeta,
					thread,
					scope: currentScope,
					done: donefn,
					processingFlagPath
				}
				console.log(`running ${execParams.action._stack || ""}/${execParams.action.name || execParams.action.type || "unnamed"} @ ${thread}`);

				execAction(execParams).then(result => { if (result !== "pause") donefn() })
			}
		} else {
			if (processingFlagPath) dispatch({ type: "set-data", path: processingFlagPath, payload: 0, autocreate: false })

			dispatch({ type: "set-data", path: `_local_${thread}`, payload: null, autocreate: false })
			dispatch({ type: "set-data", path: `_processing.${thread}`, payload: null, autocreate: false })

			actionDispatch({ type: "remove", thread });
			console.log("finished!");
		}
	} //else console.log("nothing to do due:", processing, currentAction);
};
